<template>
  <v-snackbar v-if="errors" v-model="err" color="primary" elevation="14">{{ errors }}</v-snackbar>
</template>

<script>
import { mapGetters } from "vuex";
import { ERROR } from "@/store/actions.type";

export default {
  name: "ErrorSnackbar",
  data() {
    return {
      err: this.errors
    };
  },
  computed: {
    ...mapGetters(["errors"])
  },
  watch: {
    errors(v) {
      this.err = v;
      setTimeout(() => {
        this.$store.dispatch(ERROR.DEL).then(() => {
          this.err = null;
        });
      }, 10000);
    }
  },
  methods: {
    clearErrors() {
      this.$store.dispatch(ERROR.DEL).then(() => {
        this.err = null;
      });
    }
  }
};
</script>

<style></style>
